
;if (typeof initTooltip === 'function') {
    initTooltip();
}

;function initTooltip(){

    var $closeBtn = '<div class="tooltip--close"></div>',
        $tooltip = $('.tooltip');

    if($tooltip.length){
        $tooltip.append($closeBtn);
        closeTooltip($tooltip);
    }
}

;function closeTooltip($tooltip) {

    var $closeBtn = $('.tooltip--close');

    $closeBtn.on('click', function(){

        var $tooltip = $(this).parent();

        $tooltip.fadeOut(300, function(){
            $tooltip.remove();
        });
    });
}